const Config = {
    requestUrl: "//api.wunderground.com/api/2d8f2b51a4e2b807"
};

export default Config;



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/